import { FC, useEffect } from 'react';
import { connect } from 'react-redux';

import { NotificationSuspensionTypes } from '~src/store/app/interfaces';
import { setNotificationsSuspended } from '~src/store/app/actions';

import ErrorPage from './ErrorPage';

interface DispatchProps {
  setNotificationsSuspended(type: NotificationSuspensionTypes): void;
}

const ErrorCatchPage: FC<DispatchProps> = props => {
  const forceReload = () => window.location.reload();
  useEffect(() => {
    props.setNotificationsSuspended('error');
    return () => props.setNotificationsSuspended(null);
  }, []);

  return (
    <ErrorPage messageKey="x.error_page.title" buttonKey="x.error_page.button" buttonAction={forceReload} />
  );
};

const mapDispatch2Props = (dispatch: any): DispatchProps => ({
  setNotificationsSuspended: type => dispatch(setNotificationsSuspended(type)),
});

const ErrorCatchPageC = connect(null, mapDispatch2Props)(ErrorCatchPage);

export default ErrorCatchPageC;
